import DealsWallet from './DealsWallet';

export default DealsWallet;
